import { BaseConnector } from './basic';
import { NETWORKS } from '../config/networks';

export class EVMConnector extends BaseConnector {
  private chain: 'eth' | 'base';

  constructor(chain: 'eth' | 'base') {
    super();
    this.chain = chain;
  }

  async connect(): Promise<string> {
    this.checkWindow();

    const { bitkeep } = window as any;
    if (!bitkeep?.ethereum) {
      throw new Error('BitKeep not installed');
    }
    const provider = bitkeep.ethereum;
    // 请求账户
    const accounts = await provider.request({
      method: 'eth_requestAccounts',
    });

    this.address = accounts[0];
    return this.address;
  }
  async switchNetwork(): Promise<string> {
    this.checkWindow();

    const { bitkeep } = window as any;
    if (!bitkeep?.ethereum) {
      throw new Error('BitKeep not installed');
    }

    const provider = bitkeep.ethereum;
    try {
      // 尝试切换到指定网络
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: NETWORKS[this.chain].chainId }],
      });
    } catch (error: any) {
      // 如果网络不存在（错误码4902），则尝试添加网络
      if (error.code === 4902) {
        await provider.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: NETWORKS[this.chain].chainId,
              chainName: NETWORKS[this.chain].name,
              rpcUrls: [NETWORKS[this.chain].rpcUrl],
              nativeCurrency: NETWORKS[this.chain].nativeCurrency,
              blockExplorerUrls: [NETWORKS[this.chain].blockExplorer],
            },
          ],
        });
        return 'success';
      } else {
        // 其他错误则向上抛出
        throw error;
      }
    }
  }
  async sendTransaction(transaction): Promise<string> {
    this.checkWindow();
    const { bitkeep } = window as any;
    if (!bitkeep?.ethereum) {
      throw new Error('BitKeep not installed');
    }
    const provider = bitkeep.ethereum;
    const txHash = await provider.request({
      method: 'eth_sendTransaction',
      params: [transaction],
    });
    return txHash;
  }
}
